<template>
	<span class="lazy-image" @click="$emit('click', $event)">
		<img :src="image" ref="img" :alt="alt" :width="width" :height="height" @load="loading = false; $emit('load')" @error="loading = false; $emit('error')" />
		<span class="svg" v-if="loading" :style="{width: imgWidth + 'px', height: imgHeight + 'px'}">
			<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="svg-loader">
				<circle cx="50" cy="50" r="45" />
			</svg>
		</span>
	</span>
</template>

<script>
	export default {
		props: ['src', 'alt', 'width', 'height'],
		data() {
			return {
				intersected: false,
				observer: null,
				loading: true,
				imgWidth: 0,
				imgHeight: 0
			};
		},
		computed: {
			image() {
				return (this.intersected)?this.src + this.$store.state.webp:'';
			}
		},
		mounted() {
			const bounds = this.$el.getBoundingClientRect();
			if(!this.width) {
				this.imgWidth = bounds.width;
			} else {
				this.imgWidth = this.width;
			}
			if(!this.height) {
				this.imgHeight = bounds.height;
			} else {
				this.imgHeight = this.height;
			}
			if(this.imgHeight > this.imgWidth) {
				this.imgHeight = this.imgWidth;
			} else {
				this.imgWidth = this.imgHeight;
			}
			
			this.observer = new IntersectionObserver((entries) => {
				const image = entries[0];
				if(image.isIntersecting) {
					this.intersected = true;
					this.observer.disconnect();
				}
			});
			this.observer.observe(this.$el);
		},
		destroyed() {
			this.observer.disconnect();
		}
	}
</script>